import React from 'react'
import './portfolio.css'
import PortImg1 from '../../assets/PortImg1.png'
import PortImg2 from '../../assets/PortImg2.png'
import PortImg3 from '../../assets/PortImg3.png'
import PortImg4 from '../../assets/PortImg4.png'
import PortImg5 from '../../assets/PortImg5.png'


const portfolio = () => {
  return (
    <section id='portfolio'>
        <h5>My Recent Projects</h5>
        <h2>Portfolio</h2>

        <div className="container portfolio__container">
            <article className='portfolio__item'>
                <div className='portfolio__item-image'>
                    <img src={PortImg1} alt='' />
                </div>
                <h3>FlexBox Socks</h3>
                <div className='portfolio__item-cta'>
                    <a href='https://github.com/Flexbox-Sox/flexbox-sox' className='btn' target='__blank'>Github</a>
                    <a href='https://flexbox-sox.herokuapp.com/' className='btn btn-primary' target='__blank'>Live Demo</a>
                </div>
            </article>

            <article className='portfolio__item'>
                <div className='portfolio__item-image'>
                    <img src={PortImg2} alt='' />
                </div>
                <h3>First Portfolio</h3>
                <div className='portfolio__item-cta'>
                    <a href='https://github.com/Nikoboykin?tab=repositories' className='btn' target='__blank'>Github</a>
                    <a href='https://cheery-macaron-c793b3.netlify.app' className='btn btn-primary' target='__blank'>Live Demo</a>
                </div>
            </article>

            <article className='portfolio__item'>
                <div className='portfolio__item-image'>
                    <img src={PortImg3} alt='' />
                </div>
                <h3>Arcade Game</h3>
                <div className='portfolio__item-cta'>
                    <a href='https://github.com/Nikoboykin/tictactoe' className='btn' target='__blank'>Github</a>
                    <a href='https://resplendent-bonbon-a7bfa6.netlify.app' className='btn btn-primary' target='__blank'>Live Demo</a>
                </div>
            </article>

            <article className='portfolio__item'>
                <div className='portfolio__item-image'>
                    <img src={PortImg4} alt='' />
                </div>
                <h3>Mock e-commerce Site</h3>
                <div className='portfolio__item-cta'>
                    <a href='https://github.com/Nikoboykin?tab=repositories' className='btn' target='__blank'>Github</a>
                    <a href='https://timely-basbousa-38c5d0.netlify.app' className='btn btn-primary' target='__blank'>Live Demo</a>
                </div>
            </article>

            <article className='portfolio__item'>
                <div className='portfolio__item-image'>
                    <img src={PortImg5} alt='' />
                </div>
                <h3>Mock Craigslist</h3>
                <div className='portfolio__item-cta'>
                    <a href='https://github.com/Nikoboykin/Strangers-Things' className='btn' target='__blank'>Github</a>
                    <a href='https://astounding-praline-c8df1a.netlify.app' className='btn btn-primary' target='__blank'>Live Demo</a>
                </div>
            </article>
        </div>
    </section>
  )
}

export default portfolio